import * as React from "react";
import MenuButton from "../MenuButton/MenuButton";

export type ButtonProps = {
  callback: () => void;
  enabledTooltip?: string;
  disabledTooltip?: string;
  disabled?: boolean;
};

export type SideViewProps = {
  itemName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  hasWritePermission: boolean;
  isValid: boolean;
  cancel: () => void;
};

function SideView({ itemName, children, cancel }: SideViewProps): JSX.Element {
  return (
    <div className="edit-container">
      <div className="edit-header">
        <span>{itemName}</span>
        <div className="edit-header-actions">
          <MenuButton type="Cancel" handleOnClick={cancel} />
        </div>
      </div>
      <div className="edit-form-form">
        <div>{children}</div>
      </div>
    </div>
  );
}

export default SideView;
